import { createFileRoute } from '@tanstack/react-router'
import { LoadingSpinner } from '@workspace/ui/components/loading-spinner'
import { FeatureFlagCard } from '../../../features/feature-flags/components/feature-flag-card'
import { useAdminFeatureFlagsQuery } from '../../../features/feature-flags/hooks/use-admin-feature-flags'

export const Route = createFileRoute('/admin/feature-flags/')({
  component: AdminFeatureFlagsPage,
})

function AdminFeatureFlagsPage() {
  const query = useAdminFeatureFlagsQuery()

  if (query.isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <LoadingSpinner size="sm" />
      </div>
    )
  }

  const items = query.data?.data?.items ?? []

  return (
    <div className="mx-auto max-w-4xl py-2">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Feature Flags</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Gate features globally or per startup. Toggle the global switch to open a feature to
          everyone; use the allowlist to grant access while the flag stays off.
        </p>
      </div>

      <div className="flex flex-col gap-4">
        {items.length === 0 && (
          <div className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
            No feature flags registered.
          </div>
        )}
        {items.map((flag) => (
          <FeatureFlagCard key={flag.key} flag={flag} />
        ))}
      </div>
    </div>
  )
}
